<nz-card [nzBordered]="false" [nzTitle]="cardTitle">
  <ng-template #cardTitle>
    <laveo-card-header
      [title]="category | rightName:currentRole?.type"
      [buttonTitle]="this.userCanAdd ? 'Ajouter un préparateur' : undefined"
      [buttonIcon]="this.userCanAdd ? 'plus' : undefined"
      [description]="description"
      [backButtonEnabled]="true"
      (backButtonClick)="goToAdmin()"
      (buttonClick)="add()"
      [isLoading]="isLoading">
    </laveo-card-header>
  </ng-template>
  <div nz-row [nzGutter]="[16, 16]">
    <form nz-form [formGroup]="searchForm">
      <div nz-row [nzGutter]="8" [nzAlign]="'middle'">
        <div nz-col *ngIf="checked.length > 0 && userCanDelete">
          <button nz-button nzType="default" nzSize="large" nz-dropdown [nzDropdownMenu]="actionMenu">
            {{ checked.length }} {{ checked.length > 1 ? 'préparateurs séléctionnés' : 'préparateur séléctionné' }}
            <i nz-icon nzType="down"></i>
          </button>
          <nz-dropdown-menu #actionMenu="nzDropdownMenu">
            <ul nz-menu nzSelectable>
              <!-- <li nz-menu-item (click)="copyChecked()">
                <i nz-icon nzType="copy"></i>
                Dupliquer
              </li> -->
              <li nz-menu-item nzDanger (click)="deleteChecked()">
                <i nz-icon nzType="delete"></i>
                Désactiver
              </li>
              <li nz-menu-divider></li>
              <li nz-menu-item (click)="checked.splice(0, checked.length)">
                <i nz-icon nzType="minus-square"></i>
                Tout déséléctionner
              </li>
            </ul>
          </nz-dropdown-menu>
        </div>
        <div nz-col nzFlex="1 1 auto">
          <nz-input-group [nzPrefix]="prefixIconSearch" nzSize="large">
            <ng-template #prefixIconSearch>
              <i nz-icon nzType="search"></i>
            </ng-template>
            <input type="text" nz-input placeholder="Rechercher un préparateur" formControlName="search" />
          </nz-input-group>
        </div>
      </div>
    </form>
    <nz-table
      nzShowSizeChanger
      [nzData]="datas ? datas.data : []"
      [nzFrontPagination]="false"
      [nzLoading]="isLoading"
      [nzTotal]="datas ? datas.metadata.totalResults : 0"
      [nzPageSize]="limit"
      [nzPageIndex]="datas ? datas.metadata.currentPage : 0"
      [nzNoResult]="emptyTemplate"
      (nzQueryParams)="setPage($event)"
      *ngIf="!error; else errorTemplate">
      <thead>
        <tr>
          <th nzWidth="60px" *ngIf="userCanDelete"></th>
          <th nzColumnKey="active" nzWidth="60px" [nzSortFn]="true">Actif</th>
          <th nzColumnKey="name" [nzSortFn]="true">Nom</th>
          <th nzColumnKey="structure" [nzSortFn]="true">Structure</th>
          <th nzColumnKey="tel">Téléphone</th>
          <th nzColumnKey="mail">Mail</th>
          <th nzColumnKey="actions" class="actions">Actions</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let preparer of datas?.data">
          <tr>
            <td [nzChecked]="checked.includes(preparer.id)" (nzCheckedChange)="setChecked($event, preparer.id)" *ngIf="userCanDelete">
            </td>
            <td><label nz-checkbox nzDisabled [(ngModel)]="preparer.active"></label></td>
            <td>{{ preparer.name }}</td>
            <td><button (click)="goToStructure(preparer)" nz-button>{{ preparer.structure.name }}<i nz-icon nzType="right-square" nzTheme="outline"></i></button></td>
            <td>{{ preparer.contacts ? (preparer.contacts[0].phoneNumber | phone | nullCoal) : '-' }}</td>
            <td>{{ preparer.contacts ? (preparer.contacts[0].mail | nullCoal) : '-' }}</td>
            <td class="actions">
              <button nz-button class="mr-8" [routerLink]="['/', 'admin', 'preparers', preparer.id]">
                <i nz-icon nzType="eye"></i>
                Détails
              </button>
              <button nz-button class="mr-8" (click)="edit(preparer)" *ngIf="userCanEdit">Modifier</button>
              <button nz-button nzType="primary" (click)="delete(preparer)" *ngIf="this.preparer.active && userCanDelete">
                <i nz-icon nzType="delete"></i>
              </button>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </nz-table>
    <ng-template #errorTemplate>
      <nz-result
        nzTitle="Erreur de chargement"
        nzStatus="error"
        nzSubTitle="Une erreur est survenue lors du chargement de la liste des préparateurs">
        <div nz-result-extra>
          <button nz-button nzType="primary" (click)="loadData()">
            Réessayer
            <i nz-icon nzType="reload"></i>
          </button>
        </div>
      </nz-result>
    </ng-template>
    <ng-template #emptyTemplate>
      <nz-empty
        nzNotFoundImage="simple"
        [nzNotFoundContent]="this.userCanAdd ? 'Aucun préparateur trouvé. Commencez par en ajouter un en utilisant le bouton ci-dessous.' : 'Aucun préparateur trouvé'"
        [nzNotFoundFooter]="emptyFooter">
        <ng-template #emptyFooter>
          <button nz-button nzType="primary" (click)="add()" *ngIf="this.userCanAdd">
            <i nz-icon nzType="plus"></i>
            Ajouter un préparateur
          </button>
        </ng-template>
      </nz-empty>
    </ng-template>
  </div>
</nz-card>
